<template>
  <DatePicker
    value-type="YYYY-MM-DD"
    format="DD/MM/YYYY"
    :title="field.label"
    :placeholder="field.label"
    :show-hour="true"
    v-model="content"
    @change="setValueText"
    style="width: 100%; margin-bottom: 1em"
  ></DatePicker>
</template>

<script>
import DatePicker from "vue2-datepicker";
import "vue2-datepicker/index.css";
import "vue2-datepicker/locale/pt-br";
export default {
  components: { DatePicker },
  props: ["field"],
  data() {
    return {
      content: ""
    };
  },
  methods: {
    setValueText($event) {
      this.$emit("input", $event);
    }
  }
};
</script>
<style scoped></style>
